import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { FeaturedTheme, FeaturedTour, Media, Mote } from '../../models';
import { SwiperContainerDirective } from '../../directives';

export class MediaSlide {
    media: Media;
    link?: string;
}

export interface FeaturedSlide {
    tour: FeaturedTour,
    previewText: string,
    duration: string,
    length: string,
    price: string,
    startPlace: string,
    original: boolean
};

@Component({
    selector: 'media-swiper',
    templateUrl: './media-swiper.component.html',
    styleUrls: ['./media-swiper.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class MediaSwiperComponent implements OnInit {

    @ViewChild('mediaSwiper') private swiper: ElementRef<SwiperContainerDirective>;

    @Output() mediaChanged = new EventEmitter<Media>();

    @Input() mote: Mote;
    @Input() disableSwipe: boolean = false;
    @Input() tours: Mote[] = [];

    @Input('mediaSlides') set setSlides(slides: MediaSlide[]) {
        this.mediaSlides = slides;
        this.updateMediaArray();
    };
    public mediaSlides: MediaSlide[] = [];

    @Input('featuredSlides') set setFeatured(featured: FeaturedSlide[]) {
        this.featuredSlides = featured;
        this.updateMediaArray();
    }
    public featuredSlides: FeaturedSlide[] = [];

    public swiperIndex: number = 0;
    public desktopTitleLoaded: boolean = false;
    public mobileTitleLoaded: boolean = false;
    public shOriginalLoaded: boolean = false;

    // Expose to view
    public FeaturedTheme = FeaturedTheme;
    private mediaArray: Media[] = [];

    constructor() { }

    ngOnInit(): void { }

    private updateMediaArray() {
        // Concat media and featured (why oh why is this component constructed like this? idk)
        this.mediaArray = this.mediaSlides.map((mediaSlide) => mediaSlide.media).concat(this.featuredSlides.map((featured) => featured.tour.desktopBannerMedia));
    }

    public swiperChange(idx: number) {
        this.mediaChanged.emit(this.mediaArray[idx]);
    }

    public changeSlide(idx: number): void {
        this.swiper.nativeElement.swiper.slideTo(idx);
    }

    public trackByMediaKey(index: number, mediaSlide: MediaSlide): string {
        return mediaSlide.media.key;
    }

    public trackByFeaturedTourKey(index: number, featuredSlide: FeaturedSlide): string {
        return featuredSlide.tour?.key;
    }
}
